module.exports = __webpack_public_path__ + "LGFacad_8.724462ca.png";